import styled from 'styled-components';
import { AvForm } from 'availity-mobx-reactstrap-validation';

import { breakpoint } from '../../Grid';
import { upTo } from 'js/services/MediaQuery';

export default styled(AvForm)`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-areas: 'field input button';
  grid-column-gap: 0.25rem;

  ${upTo(breakpoint)`
    justify-self: end;
    padding-left: 1rem;
  `}
`;
